<template>
  <v-dialog
    v-model="isOpened"
    persistent
    scrollable
    width="910px"
  >
    <v-card v-if="hasContract">
      <v-card-title>
        <b>#{{ contract.num }}</b> - {{ contract.label }}
        <v-spacer></v-spacer>
        <v-btn icon @click="isOpened = false">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>
      <v-tabs
        v-model="activeTab"
        background-color="deep-purple lighten-5"
        light
        centered
        slider-color="primary"
      >
        <v-tab v-for="tab in tabs" :key="tab.key">
          {{ tab.label }}
        </v-tab>
      </v-tabs>
      <v-card-text class="pa-5">
        <v-tabs-items v-model="activeTab">
          <v-tab-item :key="0">
            <div class="pa-12 text-center">
              Informations générales du contrat, périodes, commentaires, etc...
            </div>
          </v-tab-item>
          <v-tab-item :key="1">
            <v-row no-gutters justify="center" align="center">
              <h3>Équipements sous contrat</h3>
              <v-spacer />
              <v-tooltip left>
                <template v-slot:activator="{ on }">
                  <v-btn :disabled="!$canWrite" fab small depressed color="primary darken-1" @click="$canWrite && (isAddEquipmentDialogOpened = true)" v-on="on">
                    <v-icon>add</v-icon>
                  </v-btn>
                </template>
                <div>Rattacher un équipment</div>
              </v-tooltip>
            </v-row>
            <div class="mt-4">
              <div
                v-for="(equipment, i) in equipments"
                :key="i"
                class="mb-3"
                cclick="openEquipment(equipment)"
              >
                <equipment-card :value="equipment" clickable></equipment-card>
              </div>
            </div>
          </v-tab-item>
        </v-tabs-items>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import EquipmentCard from '@/components/Equipments/Card.vue';

export default {
  props: {
    value: Boolean,
    contract: {
      type: Object,
      required: false,
    },
  },

  data: () => ({
    activeTab: 0,
    isAddEquipmentDialogOpened: false,
    equipments: [
      {
        id: 12,
        label: `Machine à Maki ASA 190`,
        number: ``,
        serialNumber: `987768764589787`,
        model: `ASA190`,
        brand: `Autec`,
        Maker_id: 53,
        Client_id: 54,
        Site_id: 42,
        maker: {
          id: 53,
          name: `Sushi Robots`,
          isRoot: true,
          sendAlerts: false,
          slug: `sushi-robots`,
          logo: `/images/logo/sushi-robots.png`,
        },
        client: {
          id: 54,
          name: `Super Sushis`,
          isRoot: false,
          sendAlerts: false,
          slug: ``,
          logo: null,
        },
        site: {
          id: 42,
          name: `La Rochelle`,
          Client_id: 54,
          address: ``,
          postalCode: ``,
          city: ``,
          phone1: ``,
          phone2: ``,
          email: ``,
          Domain_id: null,
          comment: ``,
          Maker_id: 53,
          Tag_id: null,
        },
      },
      {
        id: 13,
        label: `Autocuiseur à riz FRC108NC`,
        number: ``,
        serialNumber: `786265587156789`,
        model: `FRC108NC`,
        brand: `Fujimak`,
        Maker_id: 53,
        Client_id: 54,
        Site_id: 42,
        maker: {
          id: 53,
          name: `Sushi Robots`,
          isRoot: true,
          sendAlerts: false,
          slug: `sushi-robots`,
          logo: `/images/logo/sushi-robots.png`,
        },
        client: {
          id: 54,
          name: `Super Sushis`,
          isRoot: false,
          sendAlerts: false,
          slug: ``,
          logo: null,
        },
        site: {
          id: 42,
          name: `La Rochelle`,
          Client_id: 54,
          address: ``,
          postalCode: ``,
          city: ``,
          phone1: ``,
          phone2: ``,
          email: ``,
          Domain_id: null,
          comment: ``,
          Maker_id: 53,
          Tag_id: null,
        },
      },
    ],
  }),

  computed: {
    isOpened: {
      get() { return this.value; },
      set(isOpened) { this.$emit(`input`, isOpened); },
    },
    hasContract() {
      return Boolean(this.contract?.id);
    },
    tabs() {
      const tabs = [
        { key: 0, label: `Infos générales` },
      ];
      tabs.push({ key: 1, label: `Équipements` });

      return tabs;
    },
  },

  methods: {
    opening() {
      this.activeTab = 0;
      this.isAddEquipmentDialogOpened = false;
    },
  },

  watch: {
    isOpened(isOpened) {
      if (isOpened) { this.opening(); }
    },
  },

  components: {
    EquipmentCard,
  },
};
</script>

<style lang="scss">
</style>
